import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { IMAGES } from "../../../assets";

const Navbar = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
		setMenuOpen(!menuOpen);
	};
  const handleResize = () => {
		setIsMobile(window.innerWidth <= 1024);
		if (window.innerWidth > 1024) {
			setMenuOpen(false); // Close menu when switching to desktop
		}
	};
  const [activeHash, setActiveHash] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname === "/") {
        const orderedSections = [
          { id: "basic-feature", hash: "#basic-feature" },
          { id: "faq", hash: "#faq" }
        ];

        let current = "";
        for (const section of orderedSections) {
          const element = document.getElementById(section.id);
          if (element) {
            const rect = element.getBoundingClientRect();
            if (rect.top <= window.innerHeight / 2) {
              current = section.hash;
            }
          }
        }
        setActiveHash(current);
      } else {
        setActiveHash(location.hash);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);

  useEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);
  return (
    <>
      <header>
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <a className="navbar-brand" href="/">
              <figure className="mb-0">
                <img
                  src={IMAGES.banner_logo}
                  alt=""
                  className="img-fluid"
                />
              </figure>
            </a>
            {isMobile && (
            <button
              className="navbar-toggler collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={toggleMenu}
            >
              <span className="navbar-toggler-icon"></span>
              <span className="navbar-toggler-icon"></span>
              <span className="navbar-toggler-icon"></span>
            </button>
            )}
            <div
              className={`collapse navbar-collapse ${menuOpen ? "show" : ""
							}`}
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ml-auto">
                <li className={`nav-item ${location.pathname === "/" && activeHash === "" ? "active" : ""}`}>
                  <a className="nav-link" style={{ color: menuOpen ? "#000" : "var(--e-global-color-white)" }} href="/">
                    Home
                  </a>
                </li>
                <li className={`nav-item ${location.pathname === "/about-us" ? "active" : ""}`}>
                  <a className="nav-link" style={{ color: menuOpen ? "#000" : "var(--e-global-color-white)" }} href="/about-us">
                    About
                  </a>
                </li>
                <li className={`nav-item ${activeHash === "#basic-feature" ? "active" : ""}`}>
                  <a className="nav-link" style={{ color: menuOpen ? "#000" : "var(--e-global-color-white)" }} href="/#basic-feature">
                    Features
                  </a>
                </li>
                <li className={`nav-item ${activeHash === "#faq" ? "active" : ""}`}>
                  <a className="nav-link" style={{ color: menuOpen ? "#000" : "var(--e-global-color-white)" }} href="/#faq">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>
      <figure className="mb-0 bannersidelayer">
        <img src={IMAGES.banner_sidelayer} alt="" />
      </figure>
    </>
  );
};

export default Navbar;
